import React, { useContext, useEffect, useState } from "react";
import Routers from "./routes/Routers";
import Footer from "./shared/footer/Footer";
import MobileNavbar from "./shared/mobile/mob-navbar/MobileNavbar";
import Navbar from "./shared/navbar/Navbar";
import FilesModal from "./components/files-modal/FilesModal";

type ViewFileType = {
  path: string;
  title?: string;
  type: string;
} | null;

type AppContextType = {
  setViewFile: React.Dispatch<React.SetStateAction<ViewFileType | undefined>>;
  innerWidth: number;
};

const AppContext = React.createContext<AppContextType | null>(null);

export const useAppContext = () => {
  const appContext = useContext(AppContext);
  return appContext;
};

function App() {
  const [viewFile, setViewFile] = useState<ViewFileType>();
  const [innerWidth, setInnerWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    window.addEventListener("resize", (e: any) => {
      console.log(e.target.innerWidth);
      setInnerWidth(e.target.innerWidth);
    });

    return () => window.removeEventListener("resize", () => {});
  }, []);

  const contextValue: AppContextType = {
    setViewFile,
    innerWidth,
  };

  return (
    <AppContext.Provider value={contextValue}>
      <MobileNavbar />
      <Navbar />
      <Routers />
      <Footer />
      {viewFile && <FilesModal file={viewFile} closeModal={() => {}} />}
    </AppContext.Provider>
  );
}

export default App;
